// extracted by mini-css-extract-plugin
export default {"contents":"eG-z","sectionHeading":"fG-z"};